export default __webpack_public_path__ + "static/media/Boolean.test.js.5217939c.snap";